import { onMounted, ref } from 'vue';
import { queryRootElement } from '@dh-io-emh/shared/src/utils/query-element.util';

export const useSrpModalTargets = () => {
  const srpModalTarget = ref<Element | null>(null);

  onMounted(() => {
    srpModalTarget.value = queryRootElement('#emh-srp-modal-target');
  });

  return {
    srpModalTarget,
  };
};
